import { Grid } from '@mui/material'
import { DataAccordion } from '../../../../../../shared-components/DataAccordion'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAgrochemicalsPerFacility,
    getCapitalGoodsAndServicesPerFacility,
    getCarHirePerFacility,
    getChemicalsAndAdditivesPerFacility,
    getDownstreamDistributionPerFacility,
    getFlightsAndAccommodationPerFacility,
    getOtherPerFacility,
    getPackagingPerFacility,
    getPetrolCardsPerFacility,
    getWasteGeneratedPerFacility,
    getWaterPerFacility,
    getWineAndGrapesPerFacility,
    getWoodenProductsPerFacility
} from '../../../../../../../actions/carbonfootprint-rework/06-dashboard/01-dashboard';
import GraphSubHeader from '../../../shared-components/GraphSubHeader';
import GraphPairForFacilities from '../../../shared-components/GraphPairForFacilities';
import MainCategoryButtons from '../../../shared-components/MainCategoryButtons';
import SubCategoryButtons from '../../../shared-components/SubCategoryButtons';
import GraphMainHeader from '../../../shared-components/GraphMainHeader';
import FacilityStackedBarGraph from '../../../shared-components/FacilityStackedBarGraph';
import { filterCategoriesForSpecialCases } from '../../../../utils/button-selection-utils';
import AgrochemicalsGraphPairForFacilities from '../../../shared-components/AgrochemicalsGraphPairForFacilities';

export const ScopeThreeConsumptionFacilities = ({ openAccordion, changeAccordion, company, title, group, year, groupName, groupFacilities }) => {
    const dispatch = useDispatch();
    const [mainCategory, setMainCategory] = useState('Waste Generated in Operations')
    const [subCategory, setSubCategory] = useState(null)

    const scopeThreeFacilityCategories = ['Waste Generated in Operations', 'Business Travel', 'Distribution', 'Purchased Goods and Services']
    const purchasedGoodsAndServicesCategories = ['Water', 'Chemicals and Additives', 'Wooden Products', 'Packaging', 'Wine and Grapes', 'Other', 'Capital Goods']
    const accordionName = 'Scope Three Consumption Facility'

    const filteredPurchasedGoodsAndServicesCategories = filterCategoriesForSpecialCases(purchasedGoodsAndServicesCategories, groupName, 'group')

    const wasteToLandfillPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToLandfillPerFacility?.data?.graph)
    const wasteToLandfillPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToLandfillPerFacility?.data?.pie)
    const wasteToCompostingPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToCompostingPerFacility?.data?.graph)
    const wasteToCompostingPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToCompostingPerFacility?.data?.pie)
    const wasteToRecyclingPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToRecyclingPerFacility?.data?.graph)
    const wasteToRecyclingPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToRecyclingPerFacility?.data?.pie)
    const wastewaterTreatmentPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.wastewaterTreatmentPerFacility?.data?.graph)
    const wastewaterTreatmentPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.wastewaterTreatmentPerFacility?.data?.pie)
    const wasteToBiocharProductionPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.wasteToBiocharProductionPerFacility?.data?.graph)
    const wasteToBiocharProductionPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.wasteToBiocharProductionPerFacility?.data?.pie)
    // Business Travel
    // -- Flights and Accommodation
    const flightsAndAccommodationPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.flightsAndAccommodationPerFacility?.data?.graph)
    const flightsAndAccommodationPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.flightsAndAccommodationPerFacility?.data?.pie)
    // -- Car Hire
    const carHireDieselPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.carHireDieselPerFacility?.data?.graph)
    const carHireDieselPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.carHireDieselPerFacility?.data?.pie)
    const carHirePetrolPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.carHirePetrolPerFacility?.data?.graph)
    const carHirePetrolPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.carHirePetrolPerFacility?.data?.pie)
    // -- Petrol Cards
    const petrolCardsDieselPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsDieselPerFacility?.data?.graph)
    const petrolCardsDieselPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsDieselPerFacility?.data?.pie)
    const petrolCardsPetrolPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsPetrolPerFacility?.data?.graph)
    const petrolCardsPetrolPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.petrolCardsPetrolPerFacility?.data?.pie)
    // -- Downstream Distribution
    const interDcDistributionPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.interDcDistributionPerFacility?.data?.graph)
    const interDcDistributionPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.interDcDistributionPerFacility?.data?.pie)
    const farmDcDistributionPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.farmDcDistributionPerFacility?.data?.graph)
    const farmDcDistributionPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.farmDcDistributionPerFacility?.data?.pie)
    const shippingDistributionPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.shippingDistributionPerFacility?.data?.graph)
    const shippingDistributionPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.shippingDistributionPerFacility?.data?.pie)
    const regionalDistributionPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.regionalDistributionPerFacility?.data?.graph)
    const regionalDistributionPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.regionalDistributionPerFacility?.data?.pie)
    // -- Water
    const waterPerFacilityGraph = useSelector((state) => state.carbonFootprintDashboardReducer.waterPerFacility?.data?.graph)
    const waterPerFacilityPie = useSelector((state) => state.carbonFootprintDashboardReducer.waterPerFacility?.data?.pie)
    // -- Chemicals and Additives
    const chemicalsAndAdditivesPerFacilityData = useSelector((state) => state.carbonFootprintDashboardReducer.chemicalsAndAdditivesPerFacility?.data)
    const agrochemicalsPerFacilityGraph = useSelector((state) => (state.carbonFootprintDashboardReducer.agrochemicalsPerFacility?.data?.graph))
    const agrochemicalsPerFacilityPie = useSelector((state) => (state.carbonFootprintDashboardReducer.agrochemicalsPerFacility?.data?.pie))
    // Wooden Products
    const woodenProductsPerFacilityData = useSelector((state) => state.carbonFootprintDashboardReducer.woodenProductsPerFacility?.data)
    // Packaging
    const packagingPerFacilityData = useSelector((state) => state.carbonFootprintDashboardReducer.packagingPerFacility?.data)
    // Wine and Grapes
    const wineAndGrapesLiquidsPerFacilityData = useSelector((state) => state.carbonFootprintDashboardReducer.wineAndGrapesPerFacility?.data?.liquids)
    const wineAndGrapesSolidsPerFacilityData = useSelector((state) => state.carbonFootprintDashboardReducer.wineAndGrapesPerFacility?.data?.solids)
    // Other
    const otherPerFacilityData = useSelector((state) => state.carbonFootprintDashboardReducer.otherPerFacility?.data)
    // Capital Goods and Services
    const capitalGoodsAndServicesPerFacilityData = useSelector((state) => (state.carbonFootprintDashboardReducer.capitalGoodsAndServicesPerFacility?.data))

    // Reset subCategories and mainCategories when groups change.
    useEffect(() => {
        if (mainCategory === 'Purchased Goods and Services' && subCategory) {
            setSubCategory('Water')
        }
    }, [groupName])

    useEffect(() => {
        if (openAccordion === accordionName && company && year && group && mainCategory) {
            // when mainCategory changes, we should be sure to set subCategory to null, if its
            // not already null. This could cause bugs to happen
            if (mainCategory !== 'Purchased Goods and Services' && subCategory) {
                setSubCategory(null)
            }
            else if (mainCategory === 'Waste Generated in Operations') {
                // Fetch transportation and distribution data
                dispatch(getWasteGeneratedPerFacility(company, group, year, 'waste-to-landfill'))
                dispatch(getWasteGeneratedPerFacility(company, group, year, 'waste-to-composting'))
                dispatch(getWasteGeneratedPerFacility(company, group, year, 'waste-to-recycling'))
                dispatch(getWasteGeneratedPerFacility(company, group, year, 'wastewater-treatment'))
                if (groupName !== 'Vinimark Trading') {
                    dispatch(getWasteGeneratedPerFacility(company, group, year, 'waste-to-biochar-production'))
                }
            }
            else if (mainCategory === 'Business Travel') {
                // Fetch business travel data
                dispatch(getFlightsAndAccommodationPerFacility(company, group, year));
                dispatch(getCarHirePerFacility(company, group, year, 'Diesel'));
                dispatch(getCarHirePerFacility(company, group, year, 'Petrol'));
                dispatch(getPetrolCardsPerFacility(company, group, year, 'Diesel'));
                dispatch(getPetrolCardsPerFacility(company, group, year, 'Petrol'));
            }
            else if (mainCategory === 'Employee Commuting') {
                // Fetch employee commuting data
            }
            else if (mainCategory === 'Purchased Goods and Services') {
                if (subCategory === null) {
                    setSubCategory('Water')
                }
                // fetch purchased goods and services data
                else if (subCategory === 'Water') {
                    dispatch(getWaterPerFacility(company, group, year))
                }
                else if (subCategory === 'Chemicals and Additives') {
                    dispatch(getChemicalsAndAdditivesPerFacility(company, group, year))
                    dispatch(getAgrochemicalsPerFacility(company, group, year))
                }
                else if (subCategory === 'Wooden Products') {
                    dispatch(getWoodenProductsPerFacility(company, group, year))
                }
                else if (subCategory === 'Packaging') {
                    dispatch(getPackagingPerFacility(company, group, year))
                }
                else if (subCategory === 'Wine and Grapes') {
                    dispatch(getWineAndGrapesPerFacility(company, group, year))
                }
                else if (subCategory === 'Other') {
                    dispatch(getOtherPerFacility(company, group, year))
                }
                else if (subCategory === 'Capital Goods') {
                    dispatch(getCapitalGoodsAndServicesPerFacility(company, group, year))
                }
            }
            else if (mainCategory === 'Distribution') {
                // fetch distribution data
                if (groupName === 'Vinimark Trading') {
                    // guard needless network calls
                    dispatch(getDownstreamDistributionPerFacility(company, group, year, 'Inter-DC Distribution'))
                    dispatch(getDownstreamDistributionPerFacility(company, group, year, 'Shipping Distribution'))
                }
                if (groupName !== 'Vinimark Trading') {
                    // guard needless network calls
                    dispatch(getDownstreamDistributionPerFacility(company, group, year, 'Farm-DC Distribution'))
                }
                dispatch(getDownstreamDistributionPerFacility(company, group, year, 'Regional Distribution'))
            }
        }
    }, [dispatch, openAccordion, company, year, group, mainCategory, subCategory]);

    return (
        <DataAccordion
            title={title}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <MainCategoryButtons mainCategories={scopeThreeFacilityCategories} selectedCategory={mainCategory} setSelectedCategory={setMainCategory} />

            <Grid container mb={'3rem'}>
                {mainCategory === 'Waste Generated in Operations' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Waste to Landfill</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={wasteToLandfillPerFacilityGraph}
                            pieChartData={wasteToLandfillPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Waste to Landfill'}
                            unit={'Kilograms'} />

                        <GraphSubHeader>Waste to Recycling</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={wasteToRecyclingPerFacilityGraph}
                            pieChartData={wasteToRecyclingPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Waste to Recycling'}
                            unit={'Kilograms'} />

                        <GraphSubHeader>Waste to Composting</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={wasteToCompostingPerFacilityGraph}
                            pieChartData={wasteToCompostingPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Waste to Composting'}
                            unit={'Kilograms'} />

                        <GraphSubHeader>Wastewater Treatment</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={wastewaterTreatmentPerFacilityGraph}
                            pieChartData={wastewaterTreatmentPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Wastewater Treatment'}
                            unit={'Kilolitres'} />
                        {groupName !== 'Vinimark Trading' &&
                            <>
                                <GraphSubHeader>Waste to Biochar Production</GraphSubHeader>
                                <GraphPairForFacilities
                                    barGraphData={wasteToBiocharProductionPerFacilityGraph}
                                    pieChartData={wasteToBiocharProductionPerFacilityPie}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Waste to Biochar Production'}
                                    unit={'Kilograms'} />
                            </>
                        }
                    </>
                }
                {mainCategory === 'Business Travel' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Flights and Accommodation</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={flightsAndAccommodationPerFacilityGraph}
                            pieChartData={flightsAndAccommodationPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Flights and Accommodation'}
                            unit={'kgCO2e'}
                        />
                        <GraphSubHeader>Car Hire</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={carHireDieselPerFacilityGraph}
                            pieChartData={carHireDieselPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Car Hire (Diesel)'}
                            unit={'Kilometres'}
                        />
                        <GraphPairForFacilities
                            barGraphData={carHirePetrolPerFacilityGraph}
                            pieChartData={carHirePetrolPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Car Hire (Petrol)'}
                            unit={'Kilometres'}
                        />
                        <GraphSubHeader>Petrol Cards</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={petrolCardsDieselPerFacilityGraph}
                            pieChartData={petrolCardsDieselPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Petrol Cards (Diesel)'}
                            unit={'Kilometres'}
                        />
                        <GraphPairForFacilities
                            barGraphData={petrolCardsPetrolPerFacilityGraph}
                            pieChartData={petrolCardsPetrolPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Petrol Cards (Petrol)'}
                            unit={'Kilometres'}
                        />
                    </>
                }
                {mainCategory === 'Distribution' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>

                        {groupName === 'Vinimark Trading' &&
                            <>
                                <GraphSubHeader>Inter-DC Distribution</GraphSubHeader>
                                <GraphPairForFacilities
                                    barGraphData={interDcDistributionPerFacilityGraph}
                                    pieChartData={interDcDistributionPerFacilityPie}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Inter-DC Distribution'}
                                    unit={'tonnes.km'}
                                />
                            </>
                        }
                        {groupName !== 'Vinimark Trading' &&
                            <>
                                <GraphSubHeader>Farm-DC Distribution</GraphSubHeader>
                                <GraphPairForFacilities
                                    barGraphData={farmDcDistributionPerFacilityGraph}
                                    pieChartData={farmDcDistributionPerFacilityPie}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Farm-DC Distribution'}
                                    unit={'tonnes.km'}
                                />
                            </>
                        }
                        {groupName === 'Vinimark Trading' &&
                            <>
                                <GraphSubHeader>Shipping Distribution</GraphSubHeader>
                                <GraphPairForFacilities
                                    barGraphData={shippingDistributionPerFacilityGraph}
                                    pieChartData={shippingDistributionPerFacilityPie}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Shipping Distribution'}
                                    unit={'tonnes.km'}
                                />
                            </>
                        }
                        <GraphSubHeader>Regional Distribution</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={regionalDistributionPerFacilityGraph}
                            pieChartData={regionalDistributionPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities} year={year} type={'Regional Distribution'} unit={'tonnes.km'} />
                    </>
                }
                {mainCategory === 'Purchased Goods and Services' &&
                    <>
                        <GraphMainHeader>{mainCategory} {year}</GraphMainHeader>

                        <SubCategoryButtons subCategories={filteredPurchasedGoodsAndServicesCategories} selectedSubCategory={subCategory} setSelectedSubCategory={setSubCategory} />

                        {subCategory === 'Water' &&
                            <>
                                <GraphSubHeader>Water</GraphSubHeader>
                                <GraphPairForFacilities
                                    barGraphData={waterPerFacilityGraph}
                                    pieChartData={waterPerFacilityPie}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Water'}
                                    unit={'Kilolitres'}
                                />
                            </>
                        }
                        {subCategory === 'Chemicals and Additives' &&
                            <>
                                <GraphSubHeader>Chemicals and Additives</GraphSubHeader>
                                <FacilityStackedBarGraph
                                    stackedBarGraphData={chemicalsAndAdditivesPerFacilityData}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Chemicals and Additives'}
                                    unit={'Amount'}
                                />

                                <GraphSubHeader>Agrochemicals Applied</GraphSubHeader>
                                <AgrochemicalsGraphPairForFacilities
                                    barGraphData={agrochemicalsPerFacilityGraph}
                                    pieChartData={agrochemicalsPerFacilityPie}
                                    groupName={groupName}
                                    year={year}
                                    type={'Agrochemicals Applied'}
                                    unit={'Kilograms'}
                                />
                            </>
                        }
                        {subCategory === 'Wooden Products' &&
                            <>
                                <GraphSubHeader>Wooden Products</GraphSubHeader>
                                <FacilityStackedBarGraph
                                    stackedBarGraphData={woodenProductsPerFacilityData}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Wooden Products'}
                                    unit={'Number of items'}
                                />
                            </>
                        }
                        {subCategory === 'Packaging' &&
                            <>
                                <GraphSubHeader>Packaging</GraphSubHeader>
                                <FacilityStackedBarGraph
                                    stackedBarGraphData={packagingPerFacilityData}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Packaging'}
                                    unit={'Kilograms'}
                                />
                            </>
                        }
                        {subCategory === 'Wine and Grapes' &&
                            <>
                                <GraphSubHeader>Bottled Wine and Bulk Wine</GraphSubHeader>
                                <FacilityStackedBarGraph
                                    stackedBarGraphData={wineAndGrapesLiquidsPerFacilityData}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Bottled Wine and Bulk Wine'}
                                    unit={'Kilolitres'} />

                                <GraphSubHeader>Bulk Grapes</GraphSubHeader>
                                <FacilityStackedBarGraph
                                    stackedBarGraphData={wineAndGrapesSolidsPerFacilityData}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Bulk Grapes'}
                                    unit={'Kilograms'}
                                />
                            </>
                        }
                        {subCategory === 'Other' &&
                            <>
                                <GraphSubHeader>Other</GraphSubHeader>
                                <FacilityStackedBarGraph
                                    stackedBarGraphData={otherPerFacilityData}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Other'}
                                    unit={'Reams'}
                                />
                            </>
                        }
                        {subCategory === 'Capital Goods' &&
                            <>
                                <GraphSubHeader>Capital Goods and Services</GraphSubHeader>
                                <FacilityStackedBarGraph
                                    stackedBarGraphData={capitalGoodsAndServicesPerFacilityData}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Purchased Capital Goods and Services'}
                                    unit={'Rand'}
                                />
                            </>
                        }
                    </>
                }
            </Grid>
        </DataAccordion>
    )
}